module.exports = __webpack_public_path__ + "static/img/11016C_1_2_C_20210306_fit.fab816b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11016C_1_2_C_20210306_fit.png
// module id = 08Pb
// module chunks = 0